import { NpmRegistryConfig } from "./npm-registry-settings";
import { SsoProvider } from "./sso-provider";
import { WorkspaceDefaultProjectAccessMode, WorkspaceDefaultProjectRole, WorkspaceIpSettings, WorkspaceProfileUpdate, } from "./workspace";
import { z } from "zod";
export const WorkspaceConfigurationUpdate = z.object({
    id: z.string(),
    ipWhitelist: WorkspaceIpSettings.optional(),
    sso: SsoProvider.optional(),
    npmRegistrySettings: NpmRegistryConfig.optional(),
    profile: WorkspaceProfileUpdate.optional(),
    aiFeaturesEnabled: z.boolean().optional(),
    projectsEnabled: z.boolean().optional(),
    defaultProjectAccessMode: WorkspaceDefaultProjectAccessMode.optional(),
    defaultProjectRole: WorkspaceDefaultProjectRole.optional(),
    aiAskFeaturesEnabled: z.boolean().optional(),
    aiCustomInstruction: z.string().optional(),
});
